/* (c) Copyright Frontify Ltd., all rights reserved. */

export const LIST_PLUGIN = 'list-plugin';
